module.exports = "pegasus/assets/theme5/large/1.jpg";